// extracted by mini-css-extract-plugin
module.exports = {"listHeader":"ManageClients_listHeader__XYVAr","header":"ManageClients_header__36CJJ","clientTable":"ManageClients_clientTable__3qLhW"};